import React from 'react';
import ReactPlayer from 'react-player';
import styled from "styled-components";



function Video(props) {

    
  return (
    <div>
      <ReactPlayer
        className="react-player"
        url={props.path}
        playing={props.playing}
        loop={props.loop}
        controls={props.controls}
        light={props.light}
        muted={props.muted}
        // onReady={props.onReady}
      />
    </div>
  );
}

export default Video